<p-dialog
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [visible]="editDialog"
    [style]="{width: '800px', height: '668px'}">
    <ng-template pTemplate="header">
        <span class="discard-header">Edit Details</span>
    </ng-template>
    <ng-template pTemplate="body">
        <p-tabMenu [model]="menuItems" [scrollable]="true" [activeItem]="activeItem" (activeItemChange)="onActiveItemChange($event)"></p-tabMenu>
        <ng-container *ngIf="activeItem === menuItems[0]">
            <div class="common-header-font mt-3 ml-2">Company Details</div>
            <form [formGroup]="editDetailsForm">
                <div class="flex mt-3 ml-3 mb-3">
                    <div class="flex-none">
                        <div *ngIf="!profile.ImageUrl" class="profile-avatar-empty cursor-pointer">
                            <div class="pt-3 ml-3 fs-16" (click)="handleInputProfileImgClick('idProfileImgInput')">{{profile.FirstName | slice:0:1 | uppercase}}{{profile.LastName | slice:0:1 | uppercase}}</div>
                        </div>
                        <div class="avatar-block" *ngIf="profile.ImageUrl" (mouseenter)="avatarHover = true" (mouseleave)="avatarHover = false" >
                            <img class="profile-avatar cursor-pointer" src="{{profile.ImageUrl}}" (click)="handleInputProfileImgClick('idProfileImgInput')"/>
                        </div>
                        <input id="idProfileImgInput" type="file" style="display: none" (change)="handleInputProfileImgChange($event)" required />
                    </div>
                    <div class="ml-6 flex-1">
                        <div *ngIf="isOperator()" class="mb-3">
                            <label class="sidebar-text docs-text">Company Name</label>
                            <input class="input-profile" type="text" pInputText formControlName="CompanyName" placeholder="Company Name">
                            <div *ngIf="editDetailsForm.controls['CompanyName'].invalid && (editDetailsForm.controls['CompanyName'].touched || editDetailsForm.controls['CompanyName'].dirty)">
                                <small class="error-message">Company name is required.</small>
                            </div>
                        </div>
                        <div class="flex mb-3">
                            <div class="mr-2 flex-1">
                                <label class="sidebar-text docs-text">First Name</label>
                                <input class="input-profile" type="text" pInputText formControlName="FirstName" placeholder="First Name">
                                <div *ngIf="editDetailsForm.controls['FirstName'].invalid && (editDetailsForm.controls['FirstName'].touched || editDetailsForm.controls['FirstName'].dirty)">
                                    <small class="error-message">First name is required.</small>
                                </div>
                            </div>
                            <div class="flex-1">
                                <label class="sidebar-text docs-text">Last Name</label>
                                <input class="input-profile" type="text" pInputText formControlName="LastName" placeholder="Last Name">
                                <div *ngIf="editDetailsForm.controls['LastName'].invalid && (editDetailsForm.controls['LastName'].touched || editDetailsForm.controls['LastName'].dirty)">
                                    <small class="error-message">Last name is required.</small>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label class="sidebar-text docs-text">Email</label>
                            <input class="input-profile" type="text" pInputText formControlName="Email" placeholder="Email">
                            <div *ngIf="editDetailsForm.controls['Email'].invalid && (editDetailsForm.controls['Email'].touched || editDetailsForm.controls['Email'].dirty)">
                                <small class="error-message" *ngIf="editDetailsForm.controls['Email'].errors?.['required']">Email is required.</small>
                                <small class="error-message" *ngIf="editDetailsForm.controls['Email'].errors?.['email']">Enter a valid email address.</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label class="sidebar-text docs-text">Address</label>
                    <input class="input-profile" type="text" pInputText formControlName="Address" placeholder="Address">
                    <div *ngIf="editDetailsForm.controls['Address'].invalid && (editDetailsForm.controls['Address'].touched || editDetailsForm.controls['Address'].dirty)">
                        <small class="error-message">Address is required.</small>
                    </div>
                </div>
                <div class="flex pb-3">
                    <div class="flex-1 mr-2">
                        <label class="sidebar-text docs-text">Birth Date</label>
                        <p-calendar class="input-profile" formControlName="BirthDate" [showIcon]="true" placeholder="BirthDate"></p-calendar>
                        <div *ngIf="editDetailsForm.controls['BirthDate'].invalid && (editDetailsForm.controls['BirthDate'].touched || editDetailsForm.controls['BirthDate'].dirty)">
                            <small class="error-message">Birth Date is required.</small>
                        </div>
                    </div>
                    <div class="flex-1">
                        <label class="sidebar-text docs-text">Gender</label>
                        <p-dropdown class="input-profile" placeholder="Sex" formControlName="Gender" [options]="genderList"
                                optionLabel="name" optionValue="value"></p-dropdown>
                        <div *ngIf="editDetailsForm.controls['Gender'].invalid && (editDetailsForm.controls['Gender'].touched || editDetailsForm.controls['Gender'].dirty)">
                            <small class="error-message">Gender is required.</small>
                        </div>
                    </div>
                </div>
            </form>
        </ng-container>
        <ng-container *ngIf="activeItem === menuItems[1]">
            <div class="common-header-font mt-3 ml-2 mb-3">Business Details</div>
            <div class="ml-2">
                <form [formGroup]="businessDetailsForm">
                    <div class="mb-3">
                        <label class="sidebar-text docs-text">Tax Identification Number</label>
                        <input class="input-profile" type="text" pInputText formControlName="TaxNumber" placeholder="Tax Number">
                        <div *ngIf="businessDetailsForm.controls['TaxNumber'].invalid && (businessDetailsForm.controls['TaxNumber'].touched || businessDetailsForm.controls['TaxNumber'].dirty)">
                            <small class="error-message" *ngIf="businessDetailsForm.controls['TaxNumber'].errors?.['required']">Tax Number is required.</small>
                            <small class="error-message" *ngIf="businessDetailsForm.controls['TaxNumber'].errors?.['pattern']">Enter a valid Tax Number.</small>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="sidebar-text docs-text">Bank Name</label>
                        <p-dropdown placeholder="Select a Bank" formControlName="BankTypeId" [options]="bankList" class="input-profile"
                                                           optionLabel="name" optionValue="value"></p-dropdown>
                        <div *ngIf="businessDetailsForm.controls['BankTypeId'].invalid && (businessDetailsForm.controls['BankTypeId'].touched || businessDetailsForm.controls['BankTypeId'].dirty)">
                            <small class="error-message">Bank Type is required.</small>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="sidebar-text docs-text">Account Number</label>
                        <input class="input-profile" type="text" pInputText formControlName="AccountNumber" placeholder="Account Number">
                        <div *ngIf="businessDetailsForm.controls['AccountNumber'].invalid && (businessDetailsForm.controls['AccountNumber'].touched || businessDetailsForm.controls['AccountNumber'].dirty)">
                            <small class="error-message">Account Number is required.</small>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="sidebar-text docs-text">Account Name</label>
                        <input class="input-profile" type="text" pInputText formControlName="AccountName" placeholder="Account Name">
                        <div *ngIf="businessDetailsForm.controls['AccountName'].invalid && (businessDetailsForm.controls['AccountName'].touched || businessDetailsForm.controls['AccountName'].dirty)">
                            <small class="error-message">Account Name is required.</small>
                        </div>
                    </div>
                </form>
            </div>
        </ng-container>
    </ng-template>
    <ng-template pTemplate="footer">
        <button class="btn-profile btn-default btn-border" [ngClass]="{'btn-disabled': (editDetailsForm.invalid || businessDetailsForm.invalid)}" 
        [disabled]="editDetailsForm.invalid || businessDetailsForm.invalid" (click)="updateUserProfile()">Update</button>
        <button class="btn-profile btn-default btn-discard-changes btn-cancel mr-3 btn-border" (click)="discardChanges()">Discard Changes</button>
    </ng-template>
</p-dialog>